import {debounce} from '../../../utils/debounce';
import {small} from '../../../shared/breakpoints';
import whenValueChanges from '../../../utils/whenvaluechanges';

const imageController = {
    _isSmallScreen: function() {
        return !window.matchMedia(`screen and (min-width: ${small}px)`).matches;
    },
    _setImageControl: function(isSmallScreen, productClassViewModel, $imageControl) {
        if (this._activeControl) {
            this._activeControl.destroy();
        }

        if (isSmallScreen) {
            import('./imagecontrolsmall').then(({default: ImageControlSmall}) => {
                this._activeControl = new ImageControlSmall($imageControl, productClassViewModel);
            });
        } else {
            import('./imagecontrollarge').then(({default: ImageControlLarge}) => {
                this._activeControl = new ImageControlLarge($imageControl, productClassViewModel);
            });
        }
    },
    init: function(productClassViewModel) {
        if (!productClassViewModel) {
            throw new Error('imageController.init requires a viewmodel as a parameter.');
        }

        const $imageControl = document.getElementById('image-control');

        this._setImageControl(this._isSmallScreen(), productClassViewModel, $imageControl);

        window.addEventListener(
            'resize',
            debounce(
                whenValueChanges(this._isSmallScreen, isSmallScreen =>
                    this._setImageControl(isSmallScreen, productClassViewModel, $imageControl)
                ),
                100
            )
        );
    }
};

export default imageController;
